export default __webpack_public_path__ + "static/media/br.d1e1b468.svg";